import { render, staticRenderFns } from "./AlterarReferenciaProduto.vue?vue&type=template&id=75563783&scoped=true&"
import script from "./AlterarReferenciaProduto.vue?vue&type=script&setup=true&lang=js&"
export * from "./AlterarReferenciaProduto.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AlterarReferenciaProduto.vue?vue&type=style&index=0&id=75563783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75563783",
  null
  
)

export default component.exports